import cacheableRequest from '../../../services/cacheableRequest';
import { AxiosResponse } from 'axios';
import { TrialCodes } from '../models/response';

export const getTrialCode = (brandCode: string) => {
  return cacheableRequest(`/trial/code/${brandCode}`).then((response: AxiosResponse<TrialCodes>) => response.data);
};
